import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import numeral from 'numeral';

import BaseComponent from 'base-component';

import {InputFieldViewStore, TextInputFieldViewStore, NumberInputFieldViewStore, SliderInputFieldViewStore, CheckboxInputFieldViewStore, PasswordInputFieldViewStore, RadioInputFieldViewStore, DropDownInputFieldViewStore, TextAreaInputFieldViewStore} from './viewstore';
import {InputFieldContentModel} from './contentmodel';


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class InputFieldComponent extends BaseComponent {

    static get ViewStore() {
        return InputFieldViewStore;
    }

    inputElement(props) {
        return <input {...props}/>
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            /*inputStore: {
                getInput,
                setInput,
                isDirty,
                isLoading,
                revert
            }*/
        } = this.props;

        const {
            label,
            placeholder,
            tooltip,
            variable,
            errorMessage,
            disabled,
            isReadOnly,
            required,
            css,
            tabindex,
        } = contentModel; // this contentModel's properties

        const {
            attributes,
            events,
            value,
            hovering,
            onChange,
            onFocus,
            onBlur,
            onMouseEnter,
            onMouseLeave,
            onKeyUp,
            valid,
            hasChanged,
        } = this.viewStore; // this component's viewStore.  Will have actions and UI properties

        //if(isLoading) return <div>Loading...</div>

        attributes.value = value;
        attributes.placeholder = placeholder;
        attributes.disabled = disabled || this.props.form.props.contentModel.isSubmitted;
        attributes.readOnly = isReadOnly;
        attributes.required = required;
        attributes.tabIndex = tabindex;

        var props = {};
        for(var i in attributes) {
            if(attributes[i] != null) {
                props[i] = attributes[i];
            }
        }
        for(var i in events) {
            if(events[i] != null) {
                props[i] = events[i];
            }
        }

        var self = this;
        if(!props.onChange) {
            props.onChange = function(e) { onChange(e.target.value); };
        }
        if(!props.onFocus) {
            props.onFocus = onFocus;
        }
        if(!props.onBlur) {
            props.onBlur = onBlur;
        }
        if(!props.onMouseEnter) {
            props.onMouseEnter = onMouseEnter;
        }
        if(!props.onMouseLeave) {
            props.onMouseLeave = onMouseLeave;
        }
        if(!props.onKeyUp) {
            props.onKeyUp = onKeyUp;
        }

        const showError = (hasChanged && !valid);

        return (
            <div className={"input-field " + css + (showError ? " error" : "")}>
                {tooltip && <div className="tooltip" dangerouslySetInnerHTML={{__html: tooltip}}></div>}
                <span className="input-label" dangerouslySetInnerHTML={{__html: label}}></span>
                {this.inputElement(props)}
                <div className="error-message"><i className="fa fa-fw fa-exclamation-circle"></i><span dangerouslySetInnerHTML={{__html: (errorMessage ? errorMessage : "Enter a valid value for this field.")}}></span></div>
            </div>
        )
    }
}
export default InputFieldComponent; //need to export top level component as "default"


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class TextInputFieldComponent extends InputFieldComponent {

    static get ViewStore() {
        return TextInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            minLength,
            maxLength,
            validationRegex,
        } = contentModel; // this contentModel's properties

        this.viewStore.attributes.type = "text";
        if(maxLength > 0) { this.viewStore.attributes.maxLength = maxLength; }

        return super.render();
    }
}



//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class NumberInputFieldComponent extends InputFieldComponent {
  
    static get ViewStore() {
        return NumberInputFieldViewStore;
    }

    inputElement(props) {
        const {
            value,
            hasFocus,
        } = this.viewStore;

        let format = this.props.contentModel.displayformat;
        let className = "number";

        try {
            var number = parseFloat(value);
            if(!hasFocus && format && !isNaN(number)) {
                if(format.indexOf("%") >= 0 && number >= 1) {
                    number /= 100;
                }
                if(number < 0) {
                  className += " negative";
                }
                if(format.indexOf("$0") >= 0) {
                  props.value = numeral(number).format("(" + format + ")");
                }
                else {
                  props.value = numeral(number).format(format);
                }
            }

            if(!hasFocus && isNaN(number)) {
                props.value = "";
            }
        }
        catch(e) { }

        return <input className={className} {...props}/>
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            min,
            max,
            decimals,
            displayFormat
        } = contentModel; // this contentModel's properties

        this.viewStore.attributes.type = "text";

        return super.render();
    }
}



//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class SliderInputFieldComponent extends InputFieldComponent {
  
    inputElement(props) {
        const {
            min,
            max,
            ticks,
        } = this.props.contentModel;

        if(ticks > 0) {
            var range = max - min;
            var offset = Math.round(range / ticks);

            if(!range || !offset) {
                return <input className='slider' {...props}/>;
            }

            var options = [];
            for(var counter = 0; counter <= max; counter += offset) {
                options.push(<option key={counter}>{counter}</option>);
            }
            return [
                <input key="SliderInputFieldInput" className='slider has-ticks' list={this.props.contentModel.id + "-TickList"} {...props}/>,
                <datalist key="SliderInputFieldInputDataList" id={this.props.contentModel.id + "-TickList"}>{options}</datalist>
            ];
        }
        return <input className='slider' {...props}/>;
    }

    static get ViewStore() {
        return SliderInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            min,
            max,
            step,
            ticks
        } = contentModel; // this contentModel's properties

        this.viewStore.attributes.type = "range";
        this.viewStore.attributes.min = min;
        this.viewStore.attributes.max = max;
        this.viewStore.attributes.step = step;

        return super.render();
    }
}



//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class CheckboxInputFieldComponent extends InputFieldComponent {
  
    static get ViewStore() {
        return CheckboxInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        this.viewStore.attributes.type = "checkbox";
        this.viewStore.attributes.checked = this.viewStore.checked;

        return super.render();
    }
}



//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class PasswordInputFieldComponent extends InputFieldComponent {
  
    static get ViewStore() {
        return PasswordInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            minLength,
            maxLength,
            validationRegex,
        } = contentModel; // this contentModel's properties

        this.viewStore.attributes.type = "password";
        if(maxLength > 0) { this.viewStore.attributes.maxLength = maxLength; }
        if(validationRegex && validationRegex.length > 0) { this.viewStore.attributes.pattern = validationRegex; }

        return super.render();
    }
}



//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class RadioInputFieldComponent extends InputFieldComponent {
  
    inputElement(props) {
        const {
            id,
            options
        } = this.props.contentModel;

        const value = this.viewStore.value;

        delete props.value;

        var buttons = [];
        for(var i = 0; i < options.length; ++i) {
            buttons.push(<div className='radio-button' key={id + "-RadioButtonOption" + i}><span dangerouslySetInnerHTML={{__html: options[i].label}}></span> <input name={id + "-RadioButtonGroup"} value={options[i].value} checked={options[i].value == value} {...props}/></div>);
        }
        return <div className='radio-button-group'>{buttons}</div>;
    }

    static get ViewStore() {
        return RadioInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        return super.render();
    }
}

//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class DropDownInputFieldComponent extends InputFieldComponent {
  
    inputElement(props) {
        const {
            id,
            options,
            placeholder
        } = this.props.contentModel;

        const value = this.viewStore.value;

        let entries = [];
        let hasZero = false;
        for(var i = 0; i < options.length; ++i) {
            if(options[i].value == "0") { hasZero = true; }
            entries.push(<option className="drop-down-option" key={id + "-DropDownOption" + i} value={options[i].value} dangerouslySetInnerHTML={{__html: options[i].label}}></option>);
        }
        if(!hasZero) {
            entries.unshift(<option className="drop-down-option-placeholder" key={id + "-DropDownPlaceholder"} value={null} dangerouslySetInnerHTML={{__html: placeholder}} disabled={true}></option>);
        }
        return [
            <select key="select-1" className={'drop-down' + (!hasZero && (!value || value.length == 0) ? " unselected" : "")} {...props}>{entries}</select>,
            <div key="select-2" className="input-selector"></div>
        ];
    }

    static get ViewStore() {
        return DropDownInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        return super.render();
    }
}



//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class TextAreaInputFieldComponent extends InputFieldComponent {
  
    static get ViewStore() {
        return TextAreaInputFieldViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
        } = this.props;

        const {
            minLength,
            maxLength,
            validationRegex,
        } = contentModel; // this contentModel's properties

        this.viewStore.attributes.type = "textarea";
        if(maxLength > 0) { this.viewStore.attributes.maxLength = maxLength; }
        if(validationRegex && validationRegex.length > 0) { this.viewStore.attributes.pattern = validationRegex; }

        return super.render();
    }
}


// WEBPACK FOOTER //
// ./app_modules/form-control-activity/inputFields/component.js